import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import HerePolylines from './HerePolylines';
import LeafletPolylines from './LeafletPolylines';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: LeafletPolylines,
  [TILE_LIBRARY_TYPES.JSLA]: HerePolylines,
};
